import React from "react";
import { getFreshness } from "../lib/reasoning";

// Small badge that surfaces "NEW TODAY" or "FRESH" on an opportunity row.
// Returns null when the opp isn't fresh, so the surrounding layout never
// reserves space.
const FreshnessBadge = ({ opp, size = "sm" }) => {
  const f = getFreshness(opp);
  if (!f) return null;
  const meta = f === "new_today"
    ? { label: "NEW TODAY", icon: "🆕", cls: "bg-emerald-500 text-white" }
    : { label: "FRESH",     icon: "🔥", cls: "bg-orange-500 text-white" };
  const padding = size === "lg" ? "px-2.5 py-1" : "px-2 py-0.5";
  const text = size === "lg" ? "text-[11px]" : "text-[10px]";
  return (
    <span
      className={`inline-flex items-center gap-1 ${padding} rounded-full ${text} font-bold uppercase tracking-[0.16em] ${meta.cls} animate-pulse-slow`}
      data-testid={`freshness-${f}`}
    >
      <span className="text-[10px]">{meta.icon}</span> {meta.label}
    </span>
  );
};

export default FreshnessBadge;
